import React from 'react';
import superagent from 'superagent';

import { Segment, Divider, Header } from 'semantic-ui-react'

import * as ApiUtils from '../../../CloudApi/ApiUtils.js';
import ScanRequestComponent from '../../../Fabricator/ScanRequestComponent.jsx';

export default class AccountScanRequestList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            scanRequests: []
        };
    }

    async componentDidMount() {
        return this.reload();
    }

    async reload() {
        this.setState({ loading: true });
        try {
            let schemas = await ApiUtils.getFabricatorSchemas();
            this.setState({ schemas });

            this.setState({ scanRequests: [] });
            const res = await superagent.get(`/api/admin/fabricator/account/${this.props.account.id}/scan_requests`).accept('json');
            console.log(res.body);
            this.setState({ scanRequests: res.body.items });
        } catch (e) {
            console.log(e);
        }
        this.setState({ loading: false });
    }

    render() {
        if (this.state.loading) {
            return (
                <Segment basic loading={this.state.loading} />
            )
        } else {
            return (
                <div>
                    <Header as="h2">Scan Requests</Header>
                    {this.state.scanRequests.map((scanRequest) => {
                        return (
                            <Segment>
                                <Header as="h3">Scan Request {scanRequest.id}</Header>
                                <ScanRequestComponent schemas={this.state.schemas} scanRequest={scanRequest} />
                            </Segment>
                        );
                    })}
                </div>
            );
        }
    }
}
